module.exports = __webpack_public_path__ + "media/images/icon__close--rb-gray-e307e1657e5151d1458d5f6f489a744b.png";